<template>
  <div>
    <dx-grid
      url="schoolPhones"
      :columns="columns"
      :actions="actions"
      :title="title"
      :onRowClicked="onRowClicked"
      navigationPath="onRowClicked"
      navigationField="onRowClicked"
      ref="grid"
    ></dx-grid>
    <v-dialog persistent v-model="updatePhoneDialog" max-width="1000">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0">{{
          rowClicked.id ? "Update Phone" : "Add Phone"
        }}</v-card-title>

        <v-layout row>
          <v-layout column xs6 class="pr-2" style="min-width: 50%">
            <v-text-field
              class="mx-2"
              v-model="rowClicked.recording"
              label="Recording Link"
            ></v-text-field>
            <v-layout row class="mb-3 ma-0 pa-0">
              <v-btn
                v-if="rowClicked.recording"
                @click="rowClicked.recording = null"
                flat
                class="mr-2"
                icon
                color="red"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <audio
                class="mr-3"
                v-if="rowClicked.recording"
                controls
                :src="rowClicked.recording"
              ></audio>
              <v-btn
                small
                outline
                class="mr-2"
                :loading="uploading"
                @click="pickFile()"
              >
                Upload
                <v-icon right dark>mdi-cloud-upload</v-icon>
              </v-btn>
              <input
                type="file"
                style="display: none"
                ref="files"
                accept=".mp3"
                @change="onFilePicked($event)"
              />
            </v-layout>
            <v-text-field
              class="mx-2 pt-1"
              v-model="rowClicked.did"
              label="Number"
              ref="number"
              :rules="[rules.required, rules.phoneNumber]"
            ></v-text-field>
            <v-combobox
              class="mx-2"
              v-model="rowClicked.type"
              label="Type"
              :items="types"
              ref="type"
              :rules="[rules.required]"
            ></v-combobox>
            <v-layout class="pa-0">
              <v-text-field
                class="mx-2 pt-1"
                v-model="rowClicked.description"
                label="Description"
              ></v-text-field>
              <v-btn
                class="mb-0 pt-1"
                :disabled="!rowClicked.description"
                @click="playText(rowClicked.description)"
                flat
                icon
                color="info"
              >
                <v-icon>mdi-play-circle</v-icon>
              </v-btn>
            </v-layout>
            <v-text-field
              class="mx-2 pt-1"
              v-model="rowClicked.note"
              label="Note"
            ></v-text-field>
            <v-text-field
              class="mx-2 pt-1"
              v-model="rowClicked.sortOrder"
              label="Sort Order"
              type="number"
            ></v-text-field>
            <v-text-field
              class="mx-2 pt-1"
              v-model="rowClicked.optionNumber"
              label="Option Number"
              type="number"
            ></v-text-field>
            <v-text-field
              class="mx-2 pt-1"
              v-model="rowClicked.maxDurationMinutes"
              label="Max Duration (In Minutes)"
              type="number"
              ref="maxDuration"
              :rules="[rules.minOne]"
            ></v-text-field>
            <v-switch
              color="success"
              class="mt-0 pt-0 mb-3"
              v-model="rowClicked.isEnabled"
              label="Is Enabled"
              hide-details
            ></v-switch>
            <v-switch
              color="success"
              class="mt-0 pt-0 mb-3"
              v-model="rowClicked.disableOutgoing"
              label="Disable Outgoing"
              hide-details
            ></v-switch>
            <v-select
              class="mx-2 mb-3"
              hide-details
              multiple
              label="Branches"
              chips
              v-model="rowClicked.branchList"
              :items="branches"
            ></v-select>
          </v-layout>
          <v-layout column xs6 class="pl-2" style="min-width: 50%">
            <v-layout row style="max-height: 30px;">
              <div class="title pt-1">
                Schedule when phone is off
              </div>
              <v-btn
                style="height: 28px;"
                class="my-0 ml-2"
                small
                @click="addSchedule"
                color="success"
                >Add</v-btn
              >
            </v-layout>
            <div
              class="mt-3"
              v-for="(schedule, index) in rowClicked.phoneSchedules"
            >
              <v-layout row align-center>
                <v-layout column>
                  <v-layout row>
                    <v-checkbox
                      color="success"
                      v-model="schedule.isEnabled"
                      label="Enabled"
                      class="mt-0 mr-3"
                      style="max-width: 115px"
                    >
                    </v-checkbox>
                    <v-select
                      class="pr-1 pt-0 mt-0"
                      label="Days"
                      :disabled="isDisabled(schedule)"
                      v-model="schedule.daysSelected"
                      :items="daysList"
                      ref="scheduleDays"
                      style="max-width: 300px"
                      :rules="[rules.required]"
                      multiple
                    >
                      <template
                        v-slot:selection="{
                          item,
                          index,
                        }"
                      >
                        <v-chip v-if="index === 0">
                          <span>{{ item }}</span>
                        </v-chip>
                        <span v-if="index === 1" class="grey--text caption"
                          >(+{{
                            schedule.daysSelected.length - 1
                          }}
                          others)</span
                        >
                      </template>
                    </v-select>
                  </v-layout>
                  <v-layout row>
                    <DxDateBox
                      style="height: 45px;"
                      type="time"
                      picker-type="list"
                      :interval="15"
                      class="mr-2"
                      ref="timeFrom"
                      v-model="schedule.timeFrom"
                    />
                    <DxDateBox
                      style="height: 45px;"
                      type="time"
                      picker-type="list"
                      :interval="15"
                      ref="timeTo"
                      v-model="schedule.timeTo"
                    />
                  </v-layout>
                </v-layout>
                <v-btn
                  class="pt-0 mt-0"
                  @click="addSchedule"
                  flat
                  icon
                  color="success"
                >
                  <v-icon>mdi-plus-circle</v-icon>
                </v-btn>
                <v-btn
                  class="pt-0 mt-0"
                  @click="removeSchedule(index)"
                  :disabled="isDisabled(schedule)"
                  flat
                  icon
                  color="#f55a4e"
                >
                  <v-icon>mdi-minus-circle-outline</v-icon>
                </v-btn>
              </v-layout>
              <v-divider
                class="mt-3"
                v-if="index + 1 < rowClicked.phoneSchedules.length"
              ></v-divider>
            </div>
          </v-layout>
        </v-layout>
        <v-card-actions class="mx-0 px-2 pb-2 mt-2">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="updatePhoneDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            v-if="rowClicked.id"
            color="error"
            dark
            @click="confirmDeleteDialog = true"
          >
            Delete
          </v-btn>
          <v-btn :loading="processing" color="success" @click="save()">
            Save
          </v-btn>
        </v-card-actions>
        <v-dialog v-model="confirmDeleteDialog" max-width="400">
          <v-card>
            <v-card-title class="headline pb-0">Confirm Delete</v-card-title>
            <v-card-text
              >Are you sure you want to delete this phone?</v-card-text
            >
            <v-card-actions class="pb-3 pt-0">
              <v-spacer></v-spacer>
              <v-btn color="default" dark @click="confirmDeleteDialog = false"
                >Cancel</v-btn
              >
              <v-btn
                color="error"
                :loading="processing"
                dark
                @click="deletePhone"
                >Delete</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="allowListDialog" max-width="800">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0">Allow List</v-card-title>

        <v-layout row class="ml-3">
          <v-btn small color="success" class="mb-3" @click="addAllowedNumber"
            >Add Number</v-btn
          >
          <v-btn
            small
            color="success"
            class="mb-3 ml-2"
            v-if="allowList.some((l) => l.selected)"
            @click="deleteNumbers"
            :loading="processing"
            >Delete Numbers</v-btn
          >
        </v-layout>

        <div v-for="(number, index) in newAllowListNumbers">
          <v-layout row class="pa-0 ml-3 mb-0">
            <v-text-field
              class="width-150 mr-2 pt-3"
              v-model="number.number"
              label="Number"
              :rules="[rules.required, rules.phoneNumber]"
              ref="newAllowedNumber"
            ></v-text-field>
            <v-text-field
              class="width-200 pt-3 mr-2"
              v-model="number.description"
              label="Description"
            ></v-text-field>
            <v-select
              class="width-200 mt-0"
              multiple
              label="Branches"
              chips
              v-model="number.branchList"
              :items="branches"
            ></v-select>

            <v-btn @click="addAllowedNumber" flat icon color="success">
              <v-icon>mdi-plus-circle</v-icon>
            </v-btn>
            <v-btn
              @click="removeAllowedNumber(index)"
              flat
              icon
              color="#f55a4e"
            >
              <v-icon>mdi-minus-circle-outline</v-icon>
            </v-btn>
          </v-layout>
        </div>
        <v-btn
          color="success"
          small
          class="ml-3 mt-0 mb-4"
          :loading="processing"
          @click="saveNewAllowedNumbers"
          v-if="newAllowListNumbers.length"
          >Save</v-btn
        >

        <v-layout row class="pa-0 mb-2 ml-3 font-weight-medium">
          <div class="width-50"></div>
          <div class="width-150">Number</div>
          <div class="width-200">Description</div>
          <div class="width-200">Branch</div>
        </v-layout>
        <v-divider class="pb-0 pt-3"></v-divider>
        <div style="height: 450px; overflow-y: auto;">
          <div v-for="(number, index) in allowList">
            <v-layout row class="pa-0 ml-3 mb-0" v-if="!number.editing">
              <v-checkbox
                class="width-50 my-0"
                hide-details
                v-model="number.selected"
                color="success"
              ></v-checkbox>

              <div class="width-150 pt-1">
                {{ number.number }}
              </div>
              <div class="width-200 pt-1">
                {{ number.description }}
              </div>
              <div class="width-200 pt-1">
                {{ number.branch }}
              </div>
              <v-btn
                @click="editNumber(number)"
                flat
                icon
                class="my-0"
                color="success"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </v-layout>
            <v-layout row class="pa-0 ml-3 mb-0" v-if="number.editing">
              <v-text-field
                class="width-150 mr-2 pt-3"
                v-model="number.number"
                label="Number"
                :rules="[rules.required]"
                ref="allowNumber"
              ></v-text-field>
              <v-text-field
                class="width-200 pt-3 mr-2"
                v-model="number.description"
                label="Description"
              ></v-text-field>
              <v-select
                class="width-200 mt-0"
                multiple
                label="Branches"
                chips
                v-model="number.branchList"
                :items="branches"
              ></v-select>
              <v-btn
                class="ml-2"
                color="default"
                dark
                flat
                small
                style="height: 28px;"
                @click="rollbackAllowedNumber(number)"
                >Cancel</v-btn
              >
              <v-btn
                flat
                small
                color="success"
                style="height: 28px;"
                :loading="processing"
                @click="saveNumber(number)"
                >Save</v-btn
              >
            </v-layout>
            <v-divider
              class="pb-0 pt-3"
              v-if="index + 1 < allowList.length"
            ></v-divider>
          </div>
        </div>
        <v-card-actions class="mx-0 px-2 pb-2 mt-2">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="allowListDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment";
import AWS from "aws-sdk";
import DxDateBox from "devextreme-vue/date-box";

export default {
  components: {
    DxDateBox,
  },
  data: () => ({
    title: "Phones",

    actions: [],

    updatePhoneDialog: false,
    allowListDialog: false,

    confirmDeleteDialog: false,

    allowList: [],
    newAllowListNumbers: [],

    rowClicked: {
      type: "",
      id: 0,
      description: "",
      did: "",
      note: "",
      recording: "",
      sortOrder: "",
      isEnabled: true,
      disableOutgoing: false,
      optionNumber: "",
      maxDurationMinutes: null,
      branchList: [],
      phoneSchedules: [],
    },
    processing: false,
    uploading: false,
    files: [],
    types: [],

    branches: [],

    awsPolly: "",

    daysList: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ],

    times: [
      { value: "00:00", text: "12:00 AM" },
      { value: "00:30", text: "12:30 AM" },
      { value: "01:00", text: "01:00 AM" },
      { value: "01:30", text: "01:30 AM" },
      { value: "02:00", text: "02:00 AM" },
      { value: "02:30", text: "02:30 AM" },
      { value: "03:00", text: "03:00 AM" },
      { value: "03:30", text: "03:30 AM" },
      { value: "04:00", text: "04:00 AM" },
      { value: "04:30", text: "04:30 AM" },
      { value: "05:00", text: "05:00 AM" },
      { value: "05:30", text: "05:30 AM" },
      { value: "06:00", text: "06:00 AM" },
      { value: "06:30", text: "06:30 AM" },
      { value: "07:00", text: "07:00 AM" },
      { value: "07:30", text: "07:30 AM" },
      { value: "08:00", text: "08:00 AM" },
      { value: "08:30", text: "08:30 AM" },
      { value: "09:00", text: "09:00 AM" },
      { value: "09:30", text: "09:30 AM" },
      { value: "10:00", text: "10:00 AM" },
      { value: "10:30", text: "10:30 AM" },
      { value: "11:00", text: "11:00 AM" },
      { value: "11:30", text: "11:30 AM" },
      { value: "12:00", text: "12:00 PM" },
      { value: "12:30", text: "12:30 PM" },
      { value: "13:00", text: "01:00 PM" },
      { value: "13:30", text: "01:30 PM" },
      { value: "14:00", text: "02:00 PM" },
      { value: "14:30", text: "02:30 PM" },
      { value: "15:00", text: "03:00 PM" },
      { value: "15:30", text: "03:30 PM" },
      { value: "16:00", text: "04:00 PM" },
      { value: "16:30", text: "04:30 PM" },
      { value: "17:00", text: "05:00 PM" },
      { value: "17:30", text: "05:30 PM" },
      { value: "18:00", text: "06:00 PM" },
      { value: "18:30", text: "06:30 PM" },
      { value: "19:00", text: "07:00 PM" },
      { value: "19:30", text: "07:30 PM" },
      { value: "20:00", text: "08:00 PM" },
      { value: "20:30", text: "08:30 PM" },
      { value: "21:00", text: "09:00 PM" },
      { value: "21:30", text: "09:30 PM" },
      { value: "22:00", text: "10:00 PM" },
      { value: "22:30", text: "10:30 PM" },
      { value: "23:00", text: "11:00 PM" },
      { value: "23:30", text: "11:30 PM" },
    ],

    columns: [
      {
        label: "Number",
        field: "did",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Description",
        field: "description",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Type",
        field: "type",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Recording",
        template: "link-audio-cell-template",
        field: "recording",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Note",
        field: "note",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Branches",
        field: "branches",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Sort Order",
        field: "sortOrder",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Option Number",
        field: "optionNumber",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Is Enabled",
        field: "isEnabled",
        visible: true,
        type: "boolean",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Disable Outgoing",
        field: "disableOutgoing",
        visible: true,
        type: "boolean",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],

    rules: {
      required: (value) => !!value || "Required.",
      phoneNumber: (v) => {
        return (
          !v ||
          ([10, 11].includes(v.replace(/-/g, "").length) &&
            /^\d+$/.test(v.replace(/-/g, ""))) ||
          "Invalid Phone Number"
        );
      },
      minOne: (value) => !value || value >= 1 || "Must be at least 1",
    },
  }),
  async mounted() {
    const settings = await this.getAwsSettings();

    this.awsPolly = new AWS.Polly({
      accessKeyId: settings.accessKey,
      secretAccessKey: settings.secretKey,
      region: "us-east-1",
    });
  },
  beforeDestroy() {},
  async created() {
    this.actions.push({
      text: "Add Phone",
      action: this.addNewPhone,
    });

    this.actions.push({
      text: "Allow List",
      action: this.openAllowListDialog,
    });

    await this.loadTypes();
    await this.loadBranches();
    await this.loadAllowList();
  },
  methods: {
    async getAwsSettings() {
      const response = await this.$http.get(
        "api/adminPortal/GetAwsPollyCredentials"
      );

      return response;
    },
    async onRowClicked(row) {
      this.rowClicked = JSON.parse(JSON.stringify(row));
      const branches = await this.$http.get(
        "api/schoolPhones/getBranchPhones?phoneID=" + this.rowClicked.id
      );

      this.rowClicked.branchList = branches.map((b) => b.branchCode);

      const phoneSchedules = await this.$http.get(
        "api/schoolPhones/getPhoneSchedule?phoneID=" + this.rowClicked.id
      );

      this.rowClicked.phoneSchedules = phoneSchedules.map((schedule) => {
        const date = new Date();

        schedule.timeFrom = new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          schedule.timeFrom.split(":")[0],
          schedule.timeFrom.split(":")[1]
        );
        schedule.timeTo = new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          schedule.timeTo.split(":")[0],
          schedule.timeTo.split(":")[1]
        );

        schedule.timePickerMenu = false;
        schedule.timePickerToMenu = false;
        schedule.daysSelected = this.getDaysForNumber(schedule.days).split(",");
        schedule.days = this.getDaysForNumber(schedule.days);

        return schedule;
      });

      // if (!this.rowClicked.phoneSchedules.length) {
      //     this.addSchedule();
      // }

      this.updatePhoneDialog = true;
    },
    openAllowListDialog() {
      this.allowListDialog = true;
    },
    addNewPhone() {
      this.rowClicked = {
        id: 0,
        type: "",
        description: "",
        did: "",
        note: "",
        recording: "",
        sortOrder: "",
        isEnabled: true,
        disableOutgoing: false,
        maxDurationMinutes: null,
        branchList: [],
        phoneSchedules: [],
      };

      this.updatePhoneDialog = true;
    },
    async loadTypes() {
      this.types = await this.$http.get("api/schoolPhones/getPhoneTypes");
    },
    async loadBranches() {
      const branches = await this.$http.get("api/students/getBranchList");

      this.branches = branches.filter(Boolean).sort();
    },
    async loadAllowList() {
      const response = await this.$http.get(
        "api/schoolPhones/GetSchoolPhoneAllowList"
      );

      this.allowList = response.map((number) => {
        number.editing = false;
        number.selected = false;
        number.branchList = number.branch ? number.branch.split(",") : [];

        return number;
      });
    },
    pickFile() {
      this.$refs.files.click();
    },
    async onFilePicked(e) {
      this.uploading = true;

      const files = e.target.files;

      if (!files) return;

      try {
        var formData = new FormData();

        formData.append("upload_file", files[0]);

        const response = await this.$http.post(
          "api/adminPortal/UploadFile?convertMp3=true",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        this.rowClicked.recording = response.url;
        this.uploading = false;
      } catch (e) {
        this.uploading = false;
      }
    },
    playText(text) {
      let params = {
        OutputFormat: "mp3",
        Text: text,
        TextType: "text",
        VoiceId: "Matthew",
      };

      this.awsPolly.synthesizeSpeech(params, (err, data) => {
        const uInt8Array = new Uint8Array(data.AudioStream);
        const arrayBuffer = uInt8Array.buffer;
        const blob = new Blob([arrayBuffer]);
        const url = URL.createObjectURL(blob);
        console.log(url);
        var audio = new Audio(url);
        audio.play();
      });
    },
    async save() {
      if (!this.$refs.type.validate(true) || !this.$refs.number.validate(true))
        return;

      if (
        this.rowClicked.maxDurationMinutes &&
        !this.$refs.maxDuration.validate(true)
      )
        return;

      if (!this.validateSchedules()) return;

      try {
        this.processing = true;

        const data = this.rowClicked;

        data.did = data.did.length == 11 ? data.did : "1" + data.did;

        const id = await this.$http.post("api/schoolPhones/save", data);

        await this.$http.post("api/schoolPhones/saveBranches", {
          phoneID: id,
          branches: this.rowClicked.branchList,
        });

        if (this.rowClicked.phoneSchedules) {
          await this.$http.post("api/schoolPhones/savePhoneSchedule", {
            phoneID: id,
            schedules: this.rowClicked.phoneSchedules.map((schedule) => {
              schedule.phoneID = id;
              schedule.timeFrom = this.getTime(schedule.timeFrom);
              schedule.timeTo = this.getTime(schedule.timeTo);
              schedule.days = this.getNumberForDays(schedule.daysSelected);
              return schedule;
            }),
          });
        }

        this.updatePhoneDialog = false;
        this.processing = false;

        this.$refs.grid.reloadGrid();
      } catch (e) {
        this.processing = false;
      }
    },
    getTime(time) {
      return moment(time)
        .format("HH:mm")
        .toString();
    },
    editNumber(number) {
      number.editing = true;
    },
    rollbackAllowedNumber(number) {
      number.editing = false;
    },
    addAllowedNumber() {
      this.newAllowListNumbers.push({
        number: "",
        description: "",
        branchList: [],
      });
    },
    removeAllowedNumber(index) {
      this.newAllowListNumbers.splice(index, 1);
    },
    async saveNumber(number) {
      if (!this.$refs.allowNumber.some((v) => v.validate(true))) return;

      try {
        this.processing = true;

        const data = number;

        data.branch = data.branchList.join(",");

        await this.$http.post("api/schoolPhones/SaveAllowedNumbers", [data]);

        this.processing = false;

        this.loadAllowList();
      } catch (e) {
        this.processing = false;
      }
    },
    async deleteNumbers() {
      try {
        this.processing = true;

        await this.$http.post(
          "api/schoolPhones/deleteSchoolPhoneAllowLists",
          this.allowList.filter((s) => s.selected).map((o) => o.id)
        );

        this.processing = false;

        this.loadAllowList();
      } catch (e) {
        this.processing = false;
      }
    },
    async saveNewAllowedNumbers() {
      if (!this.$refs.newAllowedNumber.some((v) => v.validate(true))) return;

      try {
        this.processing = true;

        await this.$http.post(
          "api/schoolPhones/SaveAllowedNumbers",
          this.newAllowListNumbers.map((number) => {
            number.createdBy = this.$store.state.authentication.user;
            number.branch = number.branchList.join(",");

            return number;
          })
        );

        this.processing = false;

        this.loadAllowList();

        this.newAllowListNumbers = [];
      } catch (e) {
        this.processing = false;
      }
    },
    isEmpty(str) {
      return !str || str.length === 0;
    },
    isDisabled(schedule) {
      return false;
    },
    getTimeText(time) {
      return this.times.find((t) => t.value == time).text;
    },
    saveTimeFrom(schedule, value, index) {
      this.$refs.timeFrom[index].save(value);
    },
    saveTimeTo(schedule, value, index) {
      this.$refs.timeTo[index].save(value);
    },
    addSchedule() {
      const time = moment().toDate();
      const currentTime = time.getTime();
      const updatedTime = new Date(currentTime + 2 * 60 * 60 * 1000);

      updatedTime.setMinutes(0);

      const timeFrom = updatedTime;

      const updatedTime2 = new Date(currentTime + 4 * 60 * 60 * 1000);

      updatedTime2.setMinutes(0);

      const timeTo = updatedTime2;

      this.rowClicked.phoneSchedules.push({
        days: "",
        timeFrom: timeFrom,
        timeTo: timeTo,
        branch: "",
        timePickerMenu: "",
        timePickerToMenu: "",
        isEnabled: true,
        daysSelected: [],
      });

      this.$forceUpdate();
    },
    removeSchedule(index) {
      // this.rowClicked.phoneSchedules.push(
      //     this.rowClicked.phoneSchedules[index]
      // );

      this.rowClicked.phoneSchedules.splice(index, 1);

      this.$forceUpdate();
    },
    getDaysForNumber(days) {
      const weekdays = new Array(7);

      weekdays[0] = "Sunday";
      weekdays[1] = "Monday";
      weekdays[2] = "Tuesday";
      weekdays[3] = "Wednesday";
      weekdays[4] = "Thursday";
      weekdays[5] = "Friday";
      weekdays[6] = "Saturday";

      return days
        .split(",")
        .map((day) => {
          return weekdays[day - 1];
        })
        .join(",");
    },
    getNumberForDays(days) {
      const weekdays = new Array(7);

      weekdays[0] = "Sunday";
      weekdays[1] = "Monday";
      weekdays[2] = "Tuesday";
      weekdays[3] = "Wednesday";
      weekdays[4] = "Thursday";
      weekdays[5] = "Friday";
      weekdays[6] = "Saturday";

      return days
        .map((day) => {
          return weekdays.indexOf(day) + 1;
        })
        .join(",");
    },
    validateSchedules() {
      if (
        this.rowClicked.phoneSchedules &&
        this.rowClicked.phoneSchedules.some((b) => !b.daysSelected.length)
      ) {
        this.$notify({
          text: "Missing Days",
          group: "notification",
          type: "error",
        });

        return;
      }

      if (
        this.rowClicked.phoneSchedules &&
        this.rowClicked.phoneSchedules.some((b) => !b.timeFrom)
      ) {
        this.$notify({
          text: "Missing Time From",
          group: "notification",
          type: "error",
        });

        return;
      }

      if (
        this.rowClicked.phoneSchedules &&
        this.rowClicked.phoneSchedules.some((b) => !b.timeTo)
      ) {
        this.$notify({
          text: "Missing Time To",
          group: "notification",
          type: "error",
        });

        return;
      }

      return true;
    },
    async savePhoneSchedules() {
      if (!this.validateSchedules()) return;

      const today = moment().format("YYYY-MM-DD HH:mm:ss");

      try {
        this.processing = true;

        const list = this.phoneSchedules.map((schedule) => {
          schedule.days = this.getNumberForDays(schedule.daysSelected);

          return schedule;
        });

        await this.$http.post("api/campCalls/savePhoneSchedule", {
          toUpdate: list || [],
          toDelete: this.scheduleToDelete.map((schedule) => {
            schedule.branch = schedule.branch
              ? schedule.branch.join(",")
              : this.branch;

            return schedule;
          }),
        });

        this.processing = false;
        this.scheduleToDelete = [];
        this.editingSchedule = false;
        this.loadPhoneSchedules();
      } catch (e) {
        console.log(e);
        this.processing = false;
      }
    },
    async deletePhone() {
      this.processing = true;
      try {
        await this.$http.post(
          `api/schoolPhones/deletePhone?phoneID=${this.rowClicked.id}`
        );
        this.processing = false;
        this.confirmDeleteDialog = false;
        this.updatePhoneDialog = false;
        this.$refs.grid.reloadGrid();
        this.$notify({
          type: "success",
          group: "notification",
          text: "Phone deleted successfully",
        });
      } catch (e) {
        this.processing = false;
        this.$notify({
          type: "error",
          group: "notification",
          text: "Failed to delete phone",
        });
      }
    },
  },
};
</script>
<style>
.gray-fg {
  color: #999;
}
</style>
